import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

// Selectors
import {
    makeSelectTimesheetValue,
    selectTimesheetDefaultPersonIds
    // @ts-ignore
} from 'services/timesheet/selectors';

interface ConnectedProps {
    timesheetId?: number | null;
    workTypeId?: number | null;
    entityId?: number | null;
    startDate?: string | null;
    endDate?: string | null;
    startTime?: string | null;
    endTime?: string | null;
    rate?: number | null;
    units?: number | null;
    paidBreakMinutes?: number | null;
    unpaidBreakMinutes?: number | null;
    personId?: number;
    personIds?: number[];
}

interface DispatchProps {
    updateQueryString: (parameters: any) => void;
}

type Props = ConnectedProps & DispatchProps;

export class CreateTimesheetEntriesButton extends React.PureComponent<Props> {
    handleClick = (event: React.MouseEvent<HTMLElement>) => {
        const {
            timesheetId,
            workTypeId,
            entityId,
            startDate,
            endDate,
            startTime,
            endTime,
            rate,
            units,
            paidBreakMinutes,
            unpaidBreakMinutes,
            personId,
            personIds
        } = this.props;

        this.props.updateQueryString({
            timesheetEntryModal: true,
            selectedTimesheetEntry: undefined,
            defaultValues: {
                timesheetId,
                workTypeId,
                entityId,
                startDate,
                endDate,
                startTime,
                endTime,
                rate,
                units,
                paidBreakMinutes,
                unpaidBreakMinutes,
                personIds: personId ? [personId] : personIds
            }
        });
    };

    render(): React.ReactElement {
        return (
            <CurrentSeasonInProgressGate>
                <Button
                    circular
                    secondary
                    size="small"
                    onClick={this.handleClick}
                >
                    Create
                </Button>
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    timesheetId: makeSelectTimesheetValue('id'),
    workTypeId: makeSelectTimesheetValue('workTypeId'),
    entityId: makeSelectTimesheetValue('entityId'),
    startDate: makeSelectTimesheetValue('startDate'),
    endDate: makeSelectTimesheetValue('endDate'),
    startTime: makeSelectTimesheetValue('startTime'),
    endTime: makeSelectTimesheetValue('endTime'),
    rate: makeSelectTimesheetValue('rate'),
    units: makeSelectTimesheetValue('units'),
    paidBreakMinutes: makeSelectTimesheetValue('paidBreakMinutes'),
    unpaidBreakMinutes: makeSelectTimesheetValue('unpaidBreakMinutes'),
    personId: makeSelectTimesheetValue('personId'),
    personIds: selectTimesheetDefaultPersonIds
});

export default connect(
    mapStateToProps,
    { updateQueryString }
)(CreateTimesheetEntriesButton);
